import { apiClient } from './client'

const PREFIX = '/api/internal/notifications'

export type NotificationItem = {
  id: number
  event_name: string
  title: string
  message: string
  link: string
  level: 'info' | 'success' | 'warning' | 'error' | string
  payload: Record<string, unknown>
  status: string
  is_read: boolean
  created_at: string
  sent_at: string | null
}

export type NotificationsPage = {
  count: number
  next: string | null
  previous: string | null
  results: NotificationItem[]
  unread_count: number
}

export const notificationsApi = {
  getNotifications: (params?: { page?: number; page_size?: number; unread?: boolean }) =>
    apiClient
      .get<NotificationsPage>(`${PREFIX}/`, {
        params: {
          page: params?.page,
          page_size: params?.page_size,
          ...(params?.unread ? { unread: 1 } : {}),
        },
      })
      .then((r) => r.data),

  markRead: (ids?: number[]) =>
    apiClient
      .post<{ updated_count: number }>(`${PREFIX}/mark-read/`, ids ? { ids } : {})
      .then((r) => r.data),
}
